import { useMutation } from '@tanstack/react-query';
import { printApi } from '../api/print.api';

export interface PrintResponse {
  message: string;
  paperWidthMM?: number;
  paperHeightMM?: number;
}

export const usePrint = () => {
  return useMutation<PrintResponse, Error, number>({
    mutationFn: (prescriptionId: number) => printApi.printPrescription(prescriptionId),
  });
};

